// extracted by mini-css-extract-plugin
export default {"paperPrompt":"WorkedQuestion__paperPrompt___Co_61 fonts__whitney-semibold___M7vMo"};